"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.faker = exports.randomElements = exports.randomElement = exports.randomFloat = exports.loremParagraphs = exports.loremParagraph = exports.loremSentences = exports.loremSentence = exports.loremWords = exports.loremWord = exports.fakeProductMaterial = exports.fakeProductAdjective = exports.fakePrice = exports.fakeProductName = exports.fakeProductDescription = exports.fakeProduct = exports.fakeJobArea = exports.fakeJobType = exports.fakeDepartment = exports.fakeJobTitle = exports.fakeNoun = exports.fakeBuzz = exports.fakeAdjective = exports.fakeCompanyBs = exports.fakeCompanyCatchPhrase = exports.fakeCompanyName = exports.fakeStreetAddress = exports.fakeStateAbbr = exports.fakeState = exports.fakeCity = exports.fakeZip = exports.fakeLocale = exports.fakeLastName = exports.fakeFirstName = exports.fakeId = void 0;
exports.fakePhoneNumber = fakePhoneNumber;
exports.fakeJobDescription = fakeJobDescription;
exports.fakeAnimal = fakeAnimal;
exports.fakeImageUrl = fakeImageUrl;
exports.fakeProfilePhoto = fakeProfilePhoto;
exports.fakeWebsiteUrl = fakeWebsiteUrl;
exports.fakeBoolean = fakeBoolean;
exports.randomBoolean = randomBoolean;
exports.fakeNumber = fakeNumber;
exports.randomNumber = randomNumber;
exports.randomEnum = randomEnum;
exports.randomEnums = randomEnums;
exports.randomObjectValue = randomObjectValue;
exports.randomObjectValues = randomObjectValues;
exports.randomDateBetween = randomDateBetween;
exports.fakeDateBetween = fakeDateBetween;
exports.fakeEmail = fakeEmail;
exports.setRandomSeed = setRandomSeed;
const faker_1 = require("@faker-js/faker");
Object.defineProperty(exports, "faker", { enumerable: true, get: function () { return faker_1.faker; } });
const awesome_phonenumber_1 = require("awesome-phonenumber");
/**
 * Faker utility functions
 * Represented to shorten them out
 */
exports.fakeId = faker_1.faker.string.uuid;
exports.fakeFirstName = faker_1.faker.person.firstName;
exports.fakeLastName = faker_1.faker.person.lastName;
function fakePhoneNumber() {
    return awesome_phonenumber_1.default.getExample('US').getNumber();
}
exports.fakeLocale = faker_1.faker.helpers.objectKey(faker_1.allLocales);
// Address
exports.fakeZip = faker_1.faker.location.zipCode;
exports.fakeCity = faker_1.faker.location.city;
exports.fakeState = faker_1.faker.location.state;
const fakeStateAbbr = () => faker_1.faker.location.state({ abbreviated: true });
exports.fakeStateAbbr = fakeStateAbbr;
exports.fakeStreetAddress = faker_1.faker.location.streetAddress;
// Job/Company
exports.fakeCompanyName = faker_1.faker.company.name;
exports.fakeCompanyCatchPhrase = faker_1.faker.company.catchPhrase;
exports.fakeCompanyBs = faker_1.faker.company.buzzPhrase;
exports.fakeAdjective = faker_1.faker.company.buzzAdjective;
exports.fakeBuzz = faker_1.faker.company.buzzVerb;
exports.fakeNoun = faker_1.faker.company.buzzNoun;
exports.fakeJobTitle = faker_1.faker.person.jobTitle;
exports.fakeDepartment = faker_1.faker.commerce.department;
function fakeJobDescription() {
    const descriptor = faker_1.faker.person.jobDescriptor();
    const title = (0, exports.fakeJobTitle)();
    const numParagraphs = randomNumber(0, 3);
    const summary = (0, exports.loremParagraphs)(numParagraphs);
    return `${descriptor} ${title} ${summary}`;
}
exports.fakeJobType = faker_1.faker.person.jobType;
exports.fakeJobArea = faker_1.faker.person.jobArea;
// Product
exports.fakeProduct = faker_1.faker.commerce.product;
exports.fakeProductDescription = faker_1.faker.commerce.productDescription;
exports.fakeProductName = faker_1.faker.commerce.productName;
exports.fakePrice = faker_1.faker.commerce.price;
exports.fakeProductAdjective = faker_1.faker.commerce.productAdjective;
exports.fakeProductMaterial = faker_1.faker.commerce.productMaterial;
// Lorem
exports.loremWord = faker_1.faker.lorem.word;
exports.loremWords = faker_1.faker.lorem.words;
exports.loremSentence = faker_1.faker.lorem.sentence;
exports.loremSentences = faker_1.faker.lorem.sentences;
exports.loremParagraph = faker_1.faker.lorem.paragraph;
exports.loremParagraphs = faker_1.faker.lorem.paragraphs;
// Things
function fakeAnimal() {
    const animal = faker_1.faker.animal;
    const randomFn = (0, exports.randomElement)([
        animal.bear,
        animal.bird,
        animal.cat,
        animal.cetacean,
        animal.cow,
        animal.crocodilia,
        animal.dog,
        animal.fish,
        animal.horse,
        animal.lion,
        animal.rabbit,
        animal.snake,
    ]);
    return randomFn();
}
/**
 * Returns an image url using lorem picsum - https://picsum.photos/
 * @param config
 * @returns
 */
function fakeImageUrl(config) {
    const SEED_LENGTH = 5;
    const seed = Math.floor(Math.random() * 10 ** SEED_LENGTH).toString();
    const configToUse = { width: 300, height: 300, seed, ...config };
    const imageUrl = `https://picsum.photos/seed/${configToUse.seed}/${configToUse.width}/${configToUse.height}`;
    return imageUrl;
}
function fakeProfilePhoto() {
    return faker_1.faker.image.avatar();
}
function fakeWebsiteUrl(options) {
    return faker_1.faker.internet.url(options);
}
/**
 * @deprecated Use randomBoolean - the function name makes more sense
 * @param probability
 * @returns
 */
function fakeBoolean(probability = 0.5) {
    return randomBoolean(probability);
}
function randomBoolean(probability = 0.5) {
    return Math.random() < probability;
}
/**
 * @deprecated use randomNumber - the function name makes more sense
 * @param min
 * @param max
 * @returns
 */
function fakeNumber(min, max) {
    return randomNumber(min, max);
}
function randomNumber(min, max) {
    return faker_1.faker.number.int({ min, max });
}
exports.randomFloat = faker_1.faker.number.float;
exports.randomElement = faker_1.faker.helpers.arrayElement;
exports.randomElements = faker_1.faker.helpers.arrayElements;
function randomEnum(enumerator) {
    return (0, exports.randomElement)(Object.values(enumerator));
}
function randomEnums(enumerator, count) {
    return (0, exports.randomElements)(Object.values(enumerator), count);
}
function randomObjectValue(object) {
    return (0, exports.randomElement)(Object.values(object));
}
function randomObjectValues(object, count) {
    return (0, exports.randomElements)(Object.values(object), count);
}
function randomDateBetween(from, to) {
    return faker_1.faker.date.between({ from, to });
}
/**
 * @deprecated Use randomDateBetween - the function name makes more sense
 * @param from
 * @param to
 * @returns
 */
function fakeDateBetween(from, to) {
    return randomDateBetween(from, to);
}
/**
 *
 * @param firstName
 * @param lastName
 * @param provider
 * @returns
 */
function fakeEmail(firstName, lastName, provider) {
    return faker_1.faker.internet.email({ firstName, lastName, provider });
}
/**
 * Set at the top of the test to create consistent tests
 * See https://github.com/faker-js/faker?tab=readme-ov-file#%EF%B8%8F-setting-a-randomness-seed
 * @returns The seed that was set.
 */
function setRandomSeed(seed) {
    return faker_1.faker.seed(seed);
}
